// extracted by mini-css-extract-plugin
export var content = "_v5-1";
export var wrapper = "_v5-0";